/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

import { IconButton } from "src/components/UI/Buttons/IconButtons/IconButton";
import { Like as LikeIcon } from "src/components/UI/Icons";

interface Props {
  like: () => void;
  isLiked: boolean;
  styles?: React.CSSProperties;
}
export function Like({ like, isLiked, styles }: Props) {
  return (
    <IconButton
      isSelected={isLiked}
      handleClick={() => like()}
      tooltipText={isLiked ? "Unlike" : "Like"}
      id="cy-block-like-button"
      styles={styles}
    >
      <LikeIcon />
    </IconButton>
  );
}
